import React from "react";
import get from "lodash/fp/get";
import { Column } from "~/src/components/grid";
import Stars from "~/src/components/stars";
import Icon from "~/src/components/icon";
import TimeDisplay from "~/src/components/shift-time-display";
import BookingStateDropdown from "~/src/components/BookingStateDropdown";
import {
  shiftTimes,
  formatDateFull,
  getLengthInClockHours,
  getLengthInClockHoursFromMinutes
} from "~/src/utils/formatting";
import { BOOKING_STATES_LABELS } from "~/src/consts";
import { transformBookingTimeData } from "~/src/utils/timesheetTransformations";
import {
  StyledButton,
  Text,
  BookingState,
  Row,
  CheckRow,
  CheckContainer,
  StarContaier
} from "./member-shift-list.styles";

const BookingItem = ({
  booking,
  activeTab,
  isTimesheetTab,
  onStateChange,
  onOpenBookingModal,
  onOpenShiftModal
}) => {
  const {
    startFinal,
    endFinal,
    lengthFinal,
    breakFinal
  } = transformBookingTimeData(booking);

  const displayLength = booking.timesheetMemberRow?.id
    ? getLengthInClockHoursFromMinutes(lengthFinal)
    : getLengthInClockHours(lengthFinal);

  return (
    <Row>
      <Column align="middle" gutter="none" small={8 / 12}>
        <Text>
          {booking.shift.sourceAccount.accountName}&nbsp;
          {shiftTimes(booking.shift.startTime, booking.shift.endTime)}
          {activeTab === "cancelledCount" ? (
            <BookingState>
              &nbsp;({BOOKING_STATES_LABELS[booking.state]})
            </BookingState>
          ) : null}
        </Text>
        <Text isSmall>{get("shift.venue.name", booking)}</Text>
        <Text isSmall>{get("shift.role.name", booking)}</Text>
      </Column>
      <Column align="middle" textAlign="right" gutter="none" small={4 / 12}>
        {activeTab === "previouslyAccepted" ? (
          <CheckContainer>
            <div>Check-In: {formatDateFull(startFinal)}</div>
            <CheckRow>
              <TimeDisplay
                displayDate={`Check-Out: ${formatDateFull(endFinal)}`}
                startTime={startFinal}
                endTime={endFinal}
              />
            </CheckRow>
            <Text isSmall>
              <Icon
                name={Icon.names.CLOCK}
                color={Icon.colors.CLOUDY_BLUE}
                size="xsmall"
              />
              &nbsp;
              {displayLength}h &nbsp;
              {breakFinal ? `${breakFinal}mins break` : "No break"}
            </Text>
          </CheckContainer>
        ) : null}
        {booking.ratingOfMember ? (
          <StarContaier>
            <Stars isSmall value={parseInt(booking.ratingOfMember, 10)} />
          </StarContaier>
        ) : null}
        {!isTimesheetTab && (
          <BookingStateDropdown
            currentState={booking.state}
            onChange={option => onStateChange(booking, option.value)}
            isSmall={true}
            isPrimary={true}
          />
        )}
        <StyledButton
          isSmall
          isOutline
          onClick={() =>
            onOpenBookingModal(booking.id, booking.shift.sourceAccount.id)
          }
        >
          View Booking
        </StyledButton>
        <StyledButton
          isSmall
          isOutline
          onClick={() => onOpenShiftModal(booking.shift.id)}
        >
          View Shift
        </StyledButton>
      </Column>
    </Row>
  );
};

export default BookingItem;
